'use client';
import {
  experimentInstance,
  startExperiment,
} from '@payments-checkout/shared/plugins/analitica/analitica.configs';
import { isPagarme } from '@payments-checkout/shared/helpers/constants/organizations';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { usePaymentLinkId } from '../usePaymentLinkId';

const APPLE_PAY_REDUCED_FORM_FLAG_KEY = 'apple-pay-reduced-form';

export function useApplePayReducedForm() {
  const params = useParams<{ paymentLinkId: string }>();
  const { data } = usePaymentLinkId(params?.paymentLinkId);
  const merchantId = data?.account_settings?.merchant_id;
  const accountId = data?.account_settings?.account_id;
  const isPagarmeOrganization = isPagarme(
    data?.account_settings?.organization
  );
  const amplitudeIdentifier =
    typeof window === 'undefined'
      ? null
      : sessionStorage.getItem('amplitudeIdentifier');

  const { data: isReducedForm = false } = useQuery({
    queryKey: [
      APPLE_PAY_REDUCED_FORM_FLAG_KEY,
      merchantId,
      accountId,
      amplitudeIdentifier,
    ],
    enabled: !!merchantId && !!amplitudeIdentifier && !isPagarmeOrganization,
    staleTime: Infinity,
    queryFn: async () => {
      try {
        await startExperiment({
          userId: amplitudeIdentifier,
          accountId,
          merchantId,
        });
        const variant = await experimentInstance.variant(
          APPLE_PAY_REDUCED_FORM_FLAG_KEY,
          'off'
        );
        return variant?.value === 'on';
      } catch {
        return false;
      }
    },
  });

  return isReducedForm;
}
